import { render } from "./ChatRoomInput.vue?vue&type=template&id=2cbd9804&scoped=true"
import script from "./ChatRoomInput.vue?vue&type=script&lang=js"
export * from "./ChatRoomInput.vue?vue&type=script&lang=js"

import "./ChatRoomInput.vue?vue&type=style&index=0&id=2cbd9804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbd9804"]])

export default __exports__